import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import * as _ from "../util/lodash";
var directions = {
  V: 'vertically',
  H: 'horizontally',
  VH: 'vertically horizontally',
  HV: 'horizontally vertically',
  ALL: 'all'
};
var horizontalVertical = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
directions.COMPLETE = _valuesInstanceProperty(_).call(_, directions);
directions.BASIC = [directions.V, directions.H, directions.ALL];
directions.HORIZONTAL_VERTICAL = _valuesInstanceProperty(_).call(_, horizontalVertical);

_Object$assign(directions, horizontalVertical);

export default directions;
//# sourceMappingURL=directions.js.map